import React from 'react';
import type { PolicyBlock } from '../../data/privacyPolicy';

/* Renders `**bold**` and `[label](href)` inside policy text. */
const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;
export function RichText({
  text
}: {
  text: string;
}) {
  const parts = text.split(TOKEN).filter(Boolean);
  return <>
      {parts.map((part, i) => {
      if (part.startsWith('**')) {
        return <strong key={i} className="font-semibold text-[#121A3A]" data-id="element-4070" data-mp="uel0wlzpksrf">
              {part.slice(2, -2)}
            </strong>;
      }
      const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      if (link) {
        const [, label, href] = link;
        const external = href.startsWith('http');
        return <a key={i} href={href} {...external ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {}} className="text-[#4F46E5] underline decoration-[#4F46E5]/30 underline-offset-2 hover:decoration-[#4F46E5] transition-colors duration-150 break-words" data-id="element-4071" data-mp="pmthcveyznas">
              {label}
            </a>;
      }
      return <React.Fragment key={i} data-id="element-4072" data-mp="osm86wiokjq5" data-mpi={i}>{part}</React.Fragment>;
    })}
    </>;
}
export function PolicyBlocks({
  blocks
}: {
  blocks: PolicyBlock[];
}) {
  return <>
      {blocks.map((b, i) => {
      if (b.type === 'h3') {
        return <h3 key={i} className="mt-8 font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-4073" data-mp="1cglunk8ylnyx">
              {b.text}
            </h3>;
      }
      if (b.type === 'list') {
        return <ul key={i} className="mt-4 space-y-3 pl-5 list-disc marker:text-[#4F46E5]/60" data-id="element-4074" data-mp="1metce5b2oa1z">
              {b.items.map((item, j) => <li key={j} className="pl-1 font-sans text-[15.5px] leading-[1.7] text-[#4A5168]" data-id="element-4075" data-mp="1hh9umvf61f5a" data-mpi={j}>
                  <RichText text={item} data-id="element-4076" data-mp="3o77r6vibkye6" />
                </li>)}
            </ul>;
      }
      return <p key={i} className="mt-4 font-sans text-[15.5px] leading-[1.7] text-[#4A5168]" data-id="element-4077" data-mp="3j9oazq22abjl" data-mpi={i}>
            <RichText text={b.text} data-id="element-4078" data-mp="1n69uqq5n7u5g" />
          </p>;
    })}
    </>;
}